import { format } from 'date-fns';
import { formatDateOnlyLocal } from '@erp/shared-utils';
import { ORPCError } from '@orpc/client';
import {
  fromDateTimeLocalValue,
  isSnoozeInstantInPast,
  snoozePresetUntil,
  toDateTimeLocalValue,
} from '@/lib/snoozeClock';

export {
  fromDateTimeLocalValue,
  isSnoozeInstantInPast,
  snoozePresetUntil,
  toDateTimeLocalValue,
};
import {
  APInvoiceStatus,
  INVOICE_SNOOZE_CONFIRMATION_REQUIRED,
  isActivelySnoozed,
} from '@erp/shared-types';

export { isActivelySnoozed };

export function isSnoozableInvoiceStatus(status: string): boolean {
  return status === APInvoiceStatus.DRAFT;
}

export function snoozeUntilLocalDate(until: Date): string {
  return formatDateOnlyLocal(until);
}

/** Local wall time for a "Snoozed until …" marker. */
export function formatSnoozedUntil(value: Date | string): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return format(date, 'MMM d, h:mm a');
}

export type SnoozeWarnings = { tasks: boolean; pastDue: boolean };

function confirmationCode(value: unknown): string | null {
  if (!value || typeof value !== 'object' || !('code' in value)) return null;
  return typeof value.code === 'string' ? value.code : null;
}

function trueField(value: unknown, key: 'tasks' | 'pastDue'): boolean {
  if (!value || typeof value !== 'object') return false;
  const record = value as Record<string, unknown>;
  return record[key] === true;
}

/** Warnings the server asked the caller to confirm, or null for any other error. */
export function readSnoozeConfirmation(error: unknown): SnoozeWarnings | null {
  if (!(error instanceof ORPCError)) return null;
  if (confirmationCode(error.data) !== INVOICE_SNOOZE_CONFIRMATION_REQUIRED) {
    return null;
  }
  if (!error.data || typeof error.data !== 'object') return null;
  const warnings = {
    tasks: trueField(error.data, 'tasks'),
    pastDue: trueField(error.data, 'pastDue'),
  };
  if (!warnings.tasks && !warnings.pastDue) return null;
  return warnings;
}
